import {Injectable } from '@angular/core';
import {HttpService} from "../../../services/http.service";

const baseURL: string = 'invoicing/';
const segment: string = 'attachments/';

@Injectable({
  providedIn: 'root'
})
export class InvoiceAttachmentsService {

  constructor(
      private HttpService: HttpService,
  ) {}
  check(invoice_id: number) {
    return this.HttpService.get(baseURL+'read/'+segment+'check/'+invoice_id.toString(),null );
  }
  get(invoice_id: number) {
    return this.HttpService.get(baseURL+'read/'+segment+invoice_id.toString(),null );
  }
  create(data: any) {
    return this.HttpService.post(baseURL+'create/'+segment, data);
  }
  remove(id: number ) {
    return this.HttpService.delete(baseURL+'delete/'+segment+id.toString());
  }
}
